import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class TranscriptRequestSourceFile extends ApplicationRecord {
  static jsonapiType = "transcript_request_source_files";

  @Attr() contentType: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() editingComplete: boolean;

  @Attr() endTime: number;

  @Attr() filename: string;

  @Attr() position: number;

  @Attr() startTime: number;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;
}

export default TranscriptRequestSourceFile;
